export const closeButton = 'mt-4 w-full';
